import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MfaSessionSeveritiesQueryVariables } from '../MfaSessionSeverities.generated';

export const buildMfaSessionSeveritiesQueryVariables = (
	sessionId: string
): MfaSessionSeveritiesQueryVariables => ({
	runId: buildRunIdParam(sessionId).runId
});
